import store from '@/store';

const { body } = document;
const WIDTH = 991;

export default {
  watch: {
    $route() {
      if (this.device === 'mobile' && this.open) {
        store.dispatch('closeSidebar', {
          withoutAnimation: false
        });
      }
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  mounted() {
    const isMobile = this.isMobile();
    if (isMobile) {
      store.dispatch('toggleDevice', 'mobile');
      store.dispatch('closeSidebar', {
        withoutAnimation: true
      });
    }
  },
  methods: {
    isMobile() {
      const rect = body.getBoundingClientRect();
      return rect.width - 1 < WIDTH;
    },
    resize() {
      if (!document.hidden) {
        const isMobile = this.isMobile();
        store.dispatch('toggleDevice', isMobile ? 'mobile' : 'desktop');
        if (isMobile) {
          store.dispatch('closeSidebar', {
            withoutAnimation: true
          });
        }
      }
    }
  }
};